/**
 * @fileoverview gRPC-Web generated client stub for feepb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')
const proto = {};
proto.feepb = require('./feeclearingmarginint_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.feepb.ClearingMarginIntServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.feepb.ClearingMarginIntServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.feepb.ListClearingMarginIntRequest,
 *   !proto.feepb.ListClearingMarginIntResponse>}
 */
const methodDescriptor_ClearingMarginIntService_ListClearingMarginInt = new grpc.web.MethodDescriptor(
  '/feepb.ClearingMarginIntService/ListClearingMarginInt',
  grpc.web.MethodType.UNARY,
  proto.feepb.ListClearingMarginIntRequest,
  proto.feepb.ListClearingMarginIntResponse,
  /**
   * @param {!proto.feepb.ListClearingMarginIntRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.feepb.ListClearingMarginIntResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.feepb.ListClearingMarginIntRequest,
 *   !proto.feepb.ListClearingMarginIntResponse>}
 */
const methodInfo_ClearingMarginIntService_ListClearingMarginInt = new grpc.web.AbstractClientBase.MethodInfo(
  proto.feepb.ListClearingMarginIntResponse,
  /**
   * @param {!proto.feepb.ListClearingMarginIntRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.feepb.ListClearingMarginIntResponse.deserializeBinary
);


/**
 * @param {!proto.feepb.ListClearingMarginIntRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.feepb.ListClearingMarginIntResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.feepb.ListClearingMarginIntResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.feepb.ClearingMarginIntServiceClient.prototype.listClearingMarginInt =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/feepb.ClearingMarginIntService/ListClearingMarginInt',
      request,
      metadata || {},
      methodDescriptor_ClearingMarginIntService_ListClearingMarginInt,
      callback);
};


/**
 * @param {!proto.feepb.ListClearingMarginIntRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.feepb.ListClearingMarginIntResponse>}
 *     Promise that resolves to the response
 */
proto.feepb.ClearingMarginIntServicePromiseClient.prototype.listClearingMarginInt =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/feepb.ClearingMarginIntService/ListClearingMarginInt',
      request,
      metadata || {},
      methodDescriptor_ClearingMarginIntService_ListClearingMarginInt);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.feepb.ListClearingFeeDetailsRequest,
 *   !proto.feepb.ListClearingFeeDetailsResponse>}
 */
const methodDescriptor_ClearingMarginIntService_ListClearingFeeDetails = new grpc.web.MethodDescriptor(
  '/feepb.ClearingMarginIntService/ListClearingFeeDetails',
  grpc.web.MethodType.UNARY,
  proto.feepb.ListClearingFeeDetailsRequest,
  proto.feepb.ListClearingFeeDetailsResponse,
  /**
   * @param {!proto.feepb.ListClearingFeeDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.feepb.ListClearingFeeDetailsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.feepb.ListClearingFeeDetailsRequest,
 *   !proto.feepb.ListClearingFeeDetailsResponse>}
 */
const methodInfo_ClearingMarginIntService_ListClearingFeeDetails = new grpc.web.AbstractClientBase.MethodInfo(
  proto.feepb.ListClearingFeeDetailsResponse,
  /**
   * @param {!proto.feepb.ListClearingFeeDetailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.feepb.ListClearingFeeDetailsResponse.deserializeBinary
);


/**
 * @param {!proto.feepb.ListClearingFeeDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.feepb.ListClearingFeeDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.feepb.ListClearingFeeDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.feepb.ClearingMarginIntServiceClient.prototype.listClearingFeeDetails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/feepb.ClearingMarginIntService/ListClearingFeeDetails',
      request,
      metadata || {},
      methodDescriptor_ClearingMarginIntService_ListClearingFeeDetails,
      callback);
};


/**
 * @param {!proto.feepb.ListClearingFeeDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.feepb.ListClearingFeeDetailsResponse>}
 *     Promise that resolves to the response
 */
proto.feepb.ClearingMarginIntServicePromiseClient.prototype.listClearingFeeDetails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/feepb.ClearingMarginIntService/ListClearingFeeDetails',
      request,
      metadata || {},
      methodDescriptor_ClearingMarginIntService_ListClearingFeeDetails);
};


module.exports = proto.feepb;

